import { gql, useMutation } from "@apollo/client";
import { MutationUpdateDesignerAccountArgs } from "../../__generated__/types";

const UPDATE_DESIGNER_ACCOUNT_MUTATION = gql`
  mutation UpdateDesignerAccount(
    $_id: ID!
    $firstName: String
    $lastName: String
    $email: String
    $phoneNumber: String
    $businessAddress: String
    $businessName: String
    $businessCity: String
    $businessState: States
    $businessZipCode: String
    $businessWebsite: String
    $communicationPreference: [CommunicationPreference]
    $workLocation: [String]
  ) {
    updateDesignerAccount(
      _id: $_id
      firstName: $firstName
      lastName: $lastName
      email: $email
      phoneNumber: $phoneNumber
      businessAddress: $businessAddress
      businessName: $businessName
      businessCity: $businessCity
      businessState: $businessState
      businessZipCode: $businessZipCode
      businessWebsite: $businessWebsite
      communicationPreference: $communicationPreference
      workLocation: $workLocation
    ) {
      id
      firstName
      lastName
      email
      accountType
      onboardingStatus
      subscription {
        ... on DesignerSubscriptionWrapper {
          designerValue: value
        }
        ... on HomeOwnerSubscriptionWrapper {
          homeownerValue: value
        }
      }
      businessName
      businessWebsite
      emailVerified
    }
  }
`;

export const useUpdateDesignerAccountMutation = () => {
  const [updateDesignerAccountMutation, { loading, error, data }] = useMutation(
    UPDATE_DESIGNER_ACCOUNT_MUTATION
  );

  const updateDesignerAccount = async (options: {
    variables: MutationUpdateDesignerAccountArgs;
  }) => {
    try {
      console.log("🔄 Calling updateDesignerAccount mutation with:", options);
      const result = await updateDesignerAccountMutation(options);
      console.log("📊 Mutation result:", result);
      console.log("📊 Mutation data:", result.data);
      console.log("📊 Mutation errors:", result.errors);
      console.log("📊 updateDesignerAccount result:", result.data?.updateDesignerAccount);
      console.log("📊 Full result.data structure:", JSON.stringify(result.data, null, 2));
      return result.data?.updateDesignerAccount;
    } catch (error) {
      console.error("❌ Error updating designer account:", error);
      throw error;
    }
  };

  return { updateDesignerAccount, loading, error, data };
};